module.exports = __webpack_public_path__ + "img/euro.02d96f32.svg";